import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface INovelBookIconProps extends IconPropsType {}

const NovelBookIcon = ({
  size = 16,
  fill = '#41435A',
  ...props
}: INovelBookIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8334 1.83301H13.3334V1.33301H12.8334V1.83301ZM12.8334 14.1663V14.6663H13.3334V14.1663H12.8334ZM12.8334 11.1663V11.6663H13.3334V11.1663H12.8334ZM5.83341 4.16634H5.33341V5.16634H5.83341V4.16634ZM10.1667 5.16634H10.6667V4.16634H10.1667V5.16634ZM5.83341 6.83301H5.33341V7.83301H5.83341V6.83301ZM8.16675 7.83301H8.66675V6.83301H8.16675V7.83301ZM4.50008 2.33301H12.8334V1.33301H4.50008V2.33301ZM12.3334 1.83301V14.1663H13.3334V1.83301H12.3334ZM12.8334 13.6663H4.50008V14.6663H12.8334V13.6663ZM3.66675 12.833V3.16634H2.66675V12.833H3.66675ZM4.50008 13.6663C4.03984 13.6663 3.66675 13.2932 3.66675 12.833H2.66675C2.66675 13.8455 3.48756 14.6663 4.50008 14.6663V13.6663ZM4.50008 1.33301C3.48756 1.33301 2.66675 2.15382 2.66675 3.16634H3.66675C3.66675 2.7061 4.03984 2.33301 4.50008 2.33301V1.33301ZM12.3334 7.99967V11.1663H13.3334V7.99967H12.3334ZM12.8334 10.6663H4.66675V11.6663H12.8334V10.6663ZM4.66675 14.6663H6.66675V13.6663H4.66675V14.6663ZM2.66675 12.6663C2.66675 13.7709 3.56218 14.6663 4.66675 14.6663V13.6663C4.11446 13.6663 3.66675 13.2186 3.66675 12.6663H2.66675ZM4.66675 10.6663C3.56218 10.6663 2.66675 11.5618 2.66675 12.6663H3.66675C3.66675 12.1141 4.11446 11.6663 4.66675 11.6663V10.6663ZM5.83341 5.16634H10.1667V4.16634H5.83341V5.16634ZM5.83341 7.83301H8.16675V6.83301H5.83341V7.83301Z"
      fill={fill}
    />
  </svg>
);

export default NovelBookIcon;
